import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Download, QrCode } from 'lucide-react';
import { pictureUrl } from '../../lib/api';
import { SITE_URL } from '../Seo';
import { mockData } from '../../mock';

export const MemberCard = ({ user }) => {
  const qrRef = useRef(null);
  const cardUrl = `${SITE_URL}/kort/${user.card_code}`;
  const pic = pictureUrl(user.picture);

  const downloadQr = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;
    const a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');
    a.download = `refuel-medlemskort-${user.member_number}.png`;
    a.click();
  };

  return (
    <div data-testid="member-card" className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#2a0b0b] via-[#140a1c] to-[#0f0a17] border border-[#ff2e2e]/40 p-6 md:p-8 shadow-2xl shadow-[#ff2e2e]/20">
      <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-[#ff2e2e]/15 blur-3xl pointer-events-none" />
      <div className="relative flex items-start justify-between gap-4 mb-6">
        <img src={mockData.refuelLogo} alt="Refuel Weekend logo" className="h-10 w-auto" />
        <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-white/50">Medlemskort 2027</span>
      </div>

      <div className="relative flex flex-col sm:flex-row items-center gap-6">
        <div ref={qrRef} className="rounded-2xl bg-white p-3 shrink-0" data-testid="member-card-qr">
          <QRCodeCanvas value={cardUrl} size={160} level="M" fgColor="#000000" bgColor="#ffffff" includeMargin={false} />
        </div>
        <div className="flex-1 text-center sm:text-left min-w-0">
          <div className="flex items-center justify-center sm:justify-start gap-3 mb-3">
            {pic ? (
              <img src={pic} alt={user.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#ff2e2e]" />
            ) : (
              <div className="w-12 h-12 rounded-full bg-[#ff2e2e] text-black font-bold flex items-center justify-center text-lg">{user.name?.[0]?.toUpperCase()}</div>
            )}
            <div className="min-w-0">
              <p data-testid="member-card-name" className="text-white font-bold text-lg leading-tight truncate">{user.name}</p>
              <p className="text-white/50 text-xs truncate">{user.email}</p>
            </div>
          </div>
          <p className="text-white/50 text-[10px] uppercase tracking-[0.25em] font-bold">Medlemsnummer</p>
          <p data-testid="member-card-number" className="text-3xl md:text-4xl font-bold text-[#ff2e2e] tracking-wider tabular-nums" style={{ fontFamily: "'Oktah Round', sans-serif" }}>
            {user.member_number || '—'}
          </p>
          <button type="button" onClick={downloadQr} data-testid="member-card-download-button" className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/20 text-white text-sm font-bold hover:border-[#ff2e2e] hover:text-[#ff2e2e] transition-colors">
            <Download size={16} /> Last ned QR-kode
          </button>
        </div>
      </div>
    </div>
  );
};
